import { render } from "./AppHeaderAlternative.vue?vue&type=template&id=0c5a16e8&scoped=true"
import script from "./AppHeaderAlternative.vue?vue&type=script&lang=js"
export * from "./AppHeaderAlternative.vue?vue&type=script&lang=js"

import "./AppHeaderAlternative.vue?vue&type=style&index=0&id=0c5a16e8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5a16e8"]])

export default __exports__